import DashLegend from './DashLegend';

export default DashLegend;
